
export default function refresh() {
    window.location.reload(); // if any error, we just refresh
}